import {
  PHONE_LOOKUP_REQUEST,
  PHONE_LOOKUP_SUCCESS,
  PHONE_LOOKUP_FAIL,
  PHONE_LOOKUP_RESET,
  VIRTUAL_QR_PAYMENT_REQUEST,
  VIRTUAL_QR_PAYMENT_SUCCESS,
  VIRTUAL_QR_PAYMENT_FAIL,
  VIRTUAL_QR_PAYMENT_RESET,
  VIRTUAL_QR_VERIFY_REQUEST,
  VIRTUAL_QR_VERIFY_SUCCESS,
  VIRTUAL_QR_VERIFY_FAIL,
  VIRTUAL_QR_VERIFY_RESET,
} from "../constants/phoneLookupConstants.js";
import { toast } from 'react-toastify';
import UserService from '../../services/userService';

/**
 * Phone/Email lookup action
 * @param {string} searchTerm - Phone number or email to search
 */
const phoneLookupAction = (searchTerm) => async (dispatch) => {
  try {
    dispatch({ type: PHONE_LOOKUP_REQUEST });

    const data = await UserService.phoneLookup(searchTerm);

    dispatch({
      type: PHONE_LOOKUP_SUCCESS,
      payload: data,
    });

    console.log('Phone lookup successful:', data);
    
  } catch (error) {
    console.error('Phone lookup error:', error);
    
    let errorMessage = 'Failed to search for patients';
    

    if (error.response?.data) {
      const errorData = error.response.data;
      
      if (errorData.message && Array.isArray(errorData.errors)) {
       
        const errorMessages = Object.values(errorData.errors).flat();
        errorMessage = errorData.message + ': ' + errorMessages.join(', ');
      } else if (errorData.message) {

        errorMessage = errorData.message;
      } else if (errorData.error) {
  
        errorMessage = typeof errorData.error === 'string' ? errorData.error : JSON.stringify(errorData.error);
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    dispatch({
      type: PHONE_LOOKUP_FAIL,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};

/**
 * Virtual QR payment initiation action
 * @param {number} hospitalId - Hospital ID
 * @param {number} patientId - Patient ID
 * @param {string} patientFileNumber - Patient file number
 * @param {string} patientPhone - Patient phone number
 * @param {string} email - Patient email
 * @param {string} callbackUrl - Optional callback URL for payment redirect
 */
const virtualQrPaymentAction = (hospitalId, patientId, patientFileNumber, patientPhone, email, callbackUrl = null) => async (dispatch) => {
  try {
    dispatch({ type: VIRTUAL_QR_PAYMENT_REQUEST });

    const data = await UserService.initiateVirtualQrPayment(hospitalId, patientId, patientFileNumber, patientPhone, email, callbackUrl);

    dispatch({
      type: VIRTUAL_QR_PAYMENT_SUCCESS,
      payload: data,
    });

    console.log('Virtual QR payment initiated successfully:', data);
    toast.success('Payment initiated successfully');
    
  } catch (error) {
    console.error('Virtual QR payment error:', error);
    
    let errorMessage = 'Failed to initiate payment';
    

    if (error.response?.data) {
      const errorData = error.response.data;
      
      if (errorData.message && Array.isArray(errorData.errors)) {
        const errorMessages = Object.values(errorData.errors).flat();
        errorMessage = errorData.message + ': ' + errorMessages.join(', ');
      } else if (errorData.message) {
    
        errorMessage = errorData.message;
      } else if (errorData.error) {
 
        errorMessage = typeof errorData.error === 'string' ? errorData.error : JSON.stringify(errorData.error);
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    dispatch({
      type: VIRTUAL_QR_PAYMENT_FAIL,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};

/**
 * Virtual QR payment verification action
 * @param {string} reference - Payment reference
 */
const virtualQrVerifyAction = (reference) => async (dispatch) => {
  try {
    dispatch({ type: VIRTUAL_QR_VERIFY_REQUEST });

    const data = await UserService.verifyVirtualQrPayment(reference);

    dispatch({
      type: VIRTUAL_QR_VERIFY_SUCCESS,
      payload: data,
    });

    console.log('Virtual QR payment verified successfully:', data);
    toast.success('Payment verified successfully');
    
  } catch (error) {
    console.error('Virtual QR payment verification error:', error);
    
    let errorMessage = 'Failed to verify payment';
    
    if (error.response?.data) {
      const errorData = error.response.data;
      
      if (errorData.message && Array.isArray(errorData.errors)) {
        const errorMessages = Object.values(errorData.errors).flat();
        errorMessage = errorData.message + ': ' + errorMessages.join(', ');
      } else if (errorData.message) {
 
        errorMessage = errorData.message;
      } else if (errorData.error) {
   
        errorMessage = typeof errorData.error === 'string' ? errorData.error : JSON.stringify(errorData.error);
      }
    } else if (error.message) {
      errorMessage = error.message;
    }

    dispatch({
      type: VIRTUAL_QR_VERIFY_FAIL,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};

export { phoneLookupAction, virtualQrPaymentAction, virtualQrVerifyAction };